import Storage from "./../storage";

if (!Storage.getItem("c_consent")) {
    document
        .getElementsByTagName("body")[0]
        .insertAdjacentHTML(
            "beforeend",
            '<div id="c-cookie-bar" class="c-cookie-bar"><div class="c-cookie-bar__container"><span>We use cookies to optimize your user experience. By browsing our website, you agree to the <a class="c-cookie-bar__link" target="__blank" href="https://tapfiliate.com/privacy/privacy-policy/"> use of cookies</a></span><a id="c-cookie-bar__close" class="c-cookie-bar__close">x</a></div></div>',
        );
    document.getElementById("c-cookie-bar__close").addEventListener("click", () => {
        const minutesInYear = 525600;
        Storage.setItem("c_consent", 1, minutesInYear);
        document.getElementById("c-cookie-bar").remove();
    });
}
